'use client';

import { createContext, useContext } from 'react';

const defaultIsPopNavigation = () => false;

const NavStateContext = createContext(defaultIsPopNavigation);

export const NavStateProvider = NavStateContext.Provider;

export const useIsPopNavigation = () => useContext(NavStateContext);
